import React from 'react';
import { TransitionRoute } from 'components/general/TransitionRoute';
import { EditButton, ConfirmationButton, MinimizeButton } from 'components/general/StandardButtons';
import { Input } from 'antd';
import { SectionTemplate } from 'lib/data/model';
import { IBaseProps } from 'lib/data/interfaces';
interface ISectionTemplateTitleProps extends IBaseProps {
    noEdit?: boolean;
    editingTitle?: boolean;
    sectionTemplate?: SectionTemplate;
    sectionTemplateName: string | undefined;
    changeSectionName?(): void;
    setState?({ }): void;
    handleTitleInput?(event): void;
}

export const SectionTemplateTitle = (props: ISectionTemplateTitleProps) =>
    (
        <div>
            <TransitionRoute on={props.editingTitle?props.editingTitle:false} case={false}>
                <div className="section-template-title-wrapper">
                    <h3>{props.sectionTemplate ? props.sectionTemplate.name : props.sectionTemplateName} Template</h3>
                    {props.noEdit == null ?
                        <EditButton onClick={() => {
                            if (props.setState) {
                                props.setState({ editingTitle: true })
                            }
                        }} />
                        : null}
                </div>
            </TransitionRoute>
            <TransitionRoute on={props.editingTitle?props.editingTitle:false} case={true}>
                <div className="section-template-title-wrapper">
                    <Input type="text" value={props.sectionTemplateName} onChange={props.handleTitleInput} />
                    <ConfirmationButton onClick={props.changeSectionName} />
                    <MinimizeButton onClick={() => {
                        if (props.setState) { props.setState({ editingTitle: false }) }
                    }} />
                </div>
            </TransitionRoute>
        </div>
    );
